module.exports = __webpack_public_path__ + "static/media/i-cursor.09efe202.svg";